import { useContent } from '@/services/siteData';
import { Seo } from '@/components/Seo';

export function CsrPage() {
  const { home, csr } = useContent();
  const pillars = csr.items.slice(0, 4);
  return (
    <div className="page-fade">
      <Seo
        title="Sustainability & Responsible Sourcing"
        description="Our sustainability programme: responsible sourcing, reduced waste and ethical supply for our food service and wholesale partners."
        path="/csr"
      />
      <div className="page-hero" style={{ backgroundImage: `url(${home.promos[2]?.img})` }} />
      <div className="page-head">
        <div className="eyebrow">{csr.eyebrow}</div>
        <h1>{csr.title}</h1>
        <p className="lede">{csr.lede}</p>
      </div>

      <div className="wrap" style={{ paddingBottom: 80 }}>
        <h2 className="pillars-title">
          {csr.pillarsTitle || 'We have four pillars to our sustainability programme'}
        </h2>

        <div className="pillars">
          {pillars.map((it, i) => (
            <div key={it.heading} className={'pillar' + (i % 2 === 0 ? ' alt' : '')}>
              <div className="pillar-content">
                <span className="pillar-num">Pillar {i + 1}</span>
                <h3 className="pillar-heading">{it.heading}</h3>
                <p className="pillar-body">{it.body}</p>
              </div>
              <div className="pillar-overlay" aria-hidden="true">
                <span className="pillar-num">Pillar {i + 1}</span>
                <span className="pillar-front-heading">{it.heading}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
